module.exports = __webpack_public_path__ + "img/唐县养殖业.50d32292.jpg";